import { formatInTimeZone } from "date-fns-tz"

/** RAWA works in Western Australia, so times are shown there. */
export const PERTH_TIME_ZONE = "Australia/Perth"

/** A UTC instant as people in Perth read it: "Tue 3 Nov 2026, 10:00 am". */
export const formatDateTime = (instant: string): string =>
  formatInTimeZone(instant, PERTH_TIME_ZONE, "EEE d MMM yyyy, h:mm aaa")
